import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentModes } from '../../utils';
const SaveCardCheckBox = ({ type, formik, walletItem }) => {
  const { t } = useTranslation();

  return (type === PaymentModes.PayNow || formik.values.isFullOrderAmountPaid) && !walletItem ? (
    <div className="switch_ui_main">
      <div className="switch_ui_group">
        <label className="switch_ui_label" htmlFor="saveMyCard">
          <input
            type="checkbox"
            className="switch_checkbox"
            id="saveMyCard"
            onChange={(event) => formik.setFieldValue('saveCard', event.target.checked)}
            checked={formik.values.saveCard}
          />
          <span
            className={`switch_ui ${
              formik.values.saveCard ? 'save_card_switch_active' : 'save_card_switch_default'
            }`}></span>
          <span
            className={`switch_text ${formik.values.saveCard ? 'save_card_text_active' : 'save_card_text_default'}`}>
            {t('save_card_label')}
          </span>
        </label>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default SaveCardCheckBox;
